import {
	MESApiService,
	type spParameter,
} from "../../../../services/ApiService";

export const updateAsset = async ({
	AssetIds,
	ParentAssetId,
}: {
	AssetIds: (number | string)[];
	ParentAssetId: number;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{
			name: "AssetIds",
			value: AssetIds.join(","),
		},
		{ name: "ParentAssetId", value: ParentAssetId },
	];

	const resp = await apiService.callV2(
		`[MES].[UpdateParentAssetId]`,
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when drag asset");
	}
};

export const insertAsset = async ({
	AssetName,
	ParentAssetId,
	CanBeDefaultAsset,
}: {
	AssetName: string;
	ParentAssetId: number;
	CanBeDefaultAsset: boolean | null;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "AssetName", value: AssetName },
		{ name: "ParentAssetId", value: ParentAssetId },
		{ name: "CanBeDefaultAsset", value: CanBeDefaultAsset },
	];

	const resp = await apiService.callV2(`[MES].[InsertAsset]`, parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when create asset");
	}
};

export const updateAssetData = async ({
	AssetId,
	AssetName,
	ParentAssetId,
	IsAsset,
	CanBeDefaultAsset,
}: {
	AssetId: number;
	AssetName: string;
	ParentAssetId: number;
	IsAsset: boolean;
	CanBeDefaultAsset: boolean | null;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "AssetId", value: AssetId },
		{ name: "AssetName", value: AssetName },
		{ name: "ParentAssetId", value: ParentAssetId },
		{ name: "IsAsset", value: IsAsset },
		{ name: "CanBeDefaultAsset", value: CanBeDefaultAsset },
	];

	const resp = await apiService.callV2(`[MES].[UpdateAssetData]`, parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when upsert asset");
	}
};

export const removeAsset = async ({
	AssetId,
	IsActive,
}: {
	AssetId: number;
	IsActive: boolean;
}) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "AssetId", value: AssetId },
		{ name: "IsActive", value: IsActive },
	];

	const resp = await apiService.callV2(`[MES].[RemoveAsset]`, parameters);

	if (!resp.ok) {
		throw new Error(resp.message || "Error when delete asset");
	}
};
